import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthFactoryService } from 'src/app/auth/authFactory.service';
import { SearchForm } from 'src/app/core/models/itinerary.model';
import { User } from 'src/app/core/models/models';
import { InvoluntaryChangeService } from 'src/app/involuntary-change/services/involuntary-change.service';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { VoluntaryChangeService } from 'src/app/voluntary-change/services/voluntary-change.service';
import { DashboardService } from '../../services/dashboard.service';
import { ENDPROCESS, LOCALSTORAGEVARS } from 'src/app/core/enums/enums';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  public static isFirstSearch = false;
  loading$: Observable<boolean>;
  param: SearchForm;
  public user: User;

  constructor(
    private serviceVoluntaryChange: VoluntaryChangeService,
    private serviceInvoluntaryChange: InvoluntaryChangeService,
    private serviceItinerary: ItineraryService,
    private service: DashboardService,
    private authFactoryService: AuthFactoryService
  ) {}

  ngOnInit() {
    this.skipOrClearPnrInfo();
    this.loading$ = this.service.getLoading();
    this.user = this.authFactoryService.getUser();
    sessionStorage.removeItem(ENDPROCESS.reloadedPage);
  }

  skipOrClearPnrInfo() {
    const skipClearPnrInfo =
      JSON.parse(window.localStorage.getItem(LOCALSTORAGEVARS.skipClearPnrInfo)) === true;

    if (skipClearPnrInfo) {
      /**
       * *Clear PNR info skipped
       */
    } else {
      this.serviceItinerary.dispatchClearPnrInfo();
    }

    window.localStorage.setItem(LOCALSTORAGEVARS.skipClearPnrInfo, 'false');
  }

  submitBookingSearch(searchForm: SearchForm) {
    DashboardComponent.isFirstSearch = true;
    this.serviceVoluntaryChange.dispatchClearVoluntaryChange();
    this.serviceInvoluntaryChange.dispatchClearInvoluntaryChange();
    this.service.dispatchSubmitSearch(searchForm);
  }
}
